import styled from 'styled-components';

import { InputContainer } from '@components/Input';
import FlexContainer from '@components/utils/FlexContainer';

import { Button } from '../../common/styled';
export const DynamicDiv = styled.div<{ spaceBetween?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;

  ${({ spaceBetween }) => spaceBetween && 'justify-content: space-between'};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const Content = styled.div`
  margin: 40px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
`;

export const Section = styled.section`
  margin-top: 32px;
  display: flex;
  button {
    height: unset;
    width: 148px;
    font-weight: bold;
  }
  column-gap: 20px;
  ${InputContainer} {
    flex: 1;
  }
`;
export const StyledSection = styled(Section)`
  margin: 32px 0 0 13px;
  display: flex;
`;
export const Paragraph = styled.p`
  font-size: 18px;
  padding: 0 0 30px 0;
  margin: 0;
  line-height: 1.5;
  color: ${(p) => p.theme.palette.darkGrey};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    width: 409px;
  }
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const LogoWrapper = styled.div`
  width: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
  }
  &[data-role='logo'] {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    margin-top: 40px;
    @media (max-width: 500px) {
      justify-content: center;
    }
  }
`;

export const MainWrapper = styled.div`
  height: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
  }
`;

export const HopiWrapper = styled.div`
  width: 25%;
  height: 253px;
  display: inline-flex;
  justify-content: center;
  margin-top: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  margin-left: 0;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  height: 100%;
  font-weight: bold;
  font-size: 18px;
`;

export const HopiFormRow = styled(FlexContainer)`
  display: flex;
  width: 100%;
  gap: 10px;
  div:first-child {
    flex: 2.51;
  }
  div:nth-child(2) {
    flex: 1.47;
    button {
      width: 100%;
    }
  }
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    width: 409px;
  }
`;
export const NoteWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    & span:last-of-type {
      font-size: 12px !important;
    }
  }
`;

export const MobileStyledButton = styled(Button)`
  font-size: 18px;
  font-weight: bold;
  height: 67px;
  padding: 17px 24px;
  white-space: nowrap;
`;

export const StyledFlexContainer = styled(FlexContainer)`
  box-shadow: 0px -10px 20px 0px rgba(58, 58, 58, 0.1);
  width: 100%;
  padding: 10px 40px;

  @media (max-width: 500px) {
    position: absolute;
    bottom: 0;
    left: 0;
    flex-direction: column;
    padding: 10px 0 0 0;

    & button {
      width: 100%;
    }
  }
`;
export const OptionLabel = styled.span`
  font-size: 16px;
  line-height: 20px;
  color: ${(p) => p.theme.palette.eclipse};
  font-weight: 700;
`;

export const Title = styled.span`
  font-size: 18px;
  line-height: 23px;
  color: ${(p) => p.theme.palette.eclipse};
  margin-bottom: 8px;
  font-weight: 700;
`;

export const OptionWrapper = styled(FlexContainer)`
  border-radius: 4px;
  border: 1px solid ${(p) => p.theme.palette.lightBlueGrey};
  padding: 16px;
`;
